import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Button from '../Elements/Button/Button';
import Input from '../Elements/Input/Input';
import { subscribeToNewsletter } from '../../actions/checkout';
import { purifier } from '../../utils/dom';
import { translate } from '../../utils/locale';
import s from './Newsletter.scss';
import * as Sentry from '@sentry/browser';

class Newsletter extends Component {
	constructor(props) {
		super(props);

		this.state = {
			email: '',
			sent: false,
			error: false,
		};
	}

	submitNewsletterHandler = (e) => {
		e.preventDefault();
		const { callback } = this.props;

		this.props.subscribeToNewsletter(this.state.email)
			.then(() => {
				if (callback) callback();
				window.setTimeout(() => {
					this.setState({ sent: false });
				}, 3000);
				return this.setState({ email: '', sent: true });
			})
			.catch((err) => {
				Sentry.captureException(err);
				console.log('DEBUG: err', err);
				return this.setState({ error: true });
			});
	}

	render() {
		const { setup, footer, isPopup = false } = this.props;
		const { email, sent, error } = this.state;

		const newsletterInputChangeHandler = (id, value) => {
			this.setState({
				email: value,
				error: false,
			});
		};

		return (
			<div className={[s.newsletter, (isPopup ? s.newsletter__popup : null), (sent ? s.newsletter__sent : null)].join(' ')}>
				<form className={[s.newsletter_form, (error ? s.newsletter_form__error : null)].join(' ')} onSubmit={this.submitNewsletterHandler}>
					<Input id="newsletterFooter" type="email" value={email} inputChange={newsletterInputChangeHandler} />
					<Button className={s.newsletter_form_button} type="submit" text={translate(setup, footer.newsletterButton)} />
				</form>
				<span className={s.newsletter_thanks}>{translate(setup, footer.newsletterThanks)}</span>
				<span className={s.newsletter_terms} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, footer.newsletterTerms)) }} />
			</div>
		);
	}
}

const mapState = ({ environment }, { callback }) => ({ setup: environment.setup, footer: environment.footer, callback });

export default hot(module)(connect(mapState, { subscribeToNewsletter })(Newsletter));
